import { render } from "./ContributorsTable.vue?vue&type=template&id=e73e1500&scoped=true"
import script from "./ContributorsTable.vue?vue&type=script&lang=js"
export * from "./ContributorsTable.vue?vue&type=script&lang=js"

import "./ContributorsTable.vue?vue&type=style&index=0&id=e73e1500&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e73e1500"]])

export default __exports__